<script setup lang="ts">
import {
  computed,
  navigateTo,
  ref,
  showErrorMsg,
  useRoute,
  watch,
} from '#imports';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { UserService } from '~/services/user.service';

const userService = useService(UserService);
const props = defineProps<{ teamId: number }>();

const model = defineModel('open', {
  type: Boolean,
  default: false,
});
const route = useRoute();
const eventData = computed(() => {
  return {
    page_show: route.name,
    element_name: '参与活动弹窗',
    adtag: route.query.adtag ? route.query.adtag : '',
  };
});
// team 枚举
const TEAM = {
  ICE: 10003,
  FIRE: 10004,
};

const teamKeyMap: Record<number, string> = {
  [TEAM.ICE]: 'ice',
  [TEAM.FIRE]: 'fire',
};


const teamKey = computed(() => teamKeyMap[props.teamId] || 'ice');
// 动态加载所有图片
const images = import.meta.glob<{ default: string }>(
  '~/assets/image/activity/zongzi/modal/*.png',
  { eager: true, import: 'default' },
);

function getTeamName(team: string) {
  return team === 'ice' ? '冰晶甜粽队' : '赤焰咸粽队';
}

// 获取图片路径
function getTeamImg(team: string, type: 'bg') {
  for (const key in images) {
    if (key.includes(`${team}-${type}.png`)) {
      return images[key];
    }
  }
  return '';
}
function getTeamColor(team: string) {
  return team === 'ice' ? '#1677FF' : '#FF5906';
}
const handleClose = () => {
  model.value = false;
};
// 当前 bar class
const barClass = computed(() => `bg-bar-${teamKey.value}`);
const goToActivity = () => {
  navigateTo('/oj/activity/zongzi');
  handleClose();
};
</script>
<template>
  <a-modal
    v-model:open="model"
    :centered="true"
    :width="384"
    :footer="null"
    :mask-closable="false"
    :destroy-on-close="true"
    :close-icon="false"
    :closable="false"
    :wrap-class-name="'bg-none'"
  >
    <div
      v-track:element_show="eventData"
      class="-m-6 flex h-[342px] flex-col overflow-hidden rounded-xl bg-white"
    >
      <div class="flex h-[168px] overflow-hidden">
        <img
          class="relative -top-[10px] w-full"
          :src="getTeamImg(teamKey, 'bg')"
          alt=""
        />
      </div>
      <div class="mt-2 px-2 text-center text-base font-bold">
        <p>{{ userService.user.nickname }},恭喜你已参加端午大冒险活动</p>
        <p class="mt-4">
          现在分配到了<span
            class="ml-1"
            :style="{
              color: getTeamColor(teamKey),
            }"
            >{{ getTeamName(teamKey) }}</span
          >，快开启挑战吧
        </p>
      </div>

      <div class="flex-center flex-1">
        <div
          v-track:element_click.click="eventData"
          class="flex-center h-12 w-[216px] cursor-pointer rounded bg-primary text-lg font-bold text-white"
          @click="goToActivity"
        >
          查看详情
        </div>
      </div>
    </div>

    <span
      class="absolute -bottom-[72px] left-1/2 -translate-x-1/2 cursor-pointer"
      @click="handleClose"
    >
      <img
        class="w-[32px]"
        src="~/assets/image/activity/zongzi/modal/close.svg"
        alt=""
      />
    </span>
  </a-modal>
</template>
<style scoped></style>
<style>
.bg-none .ant-modal-content {
  background-color: transparent !important;
}
</style>
